export default "__VITE_ASSET__DQnrbx4J__"